import {SupportedLocales} from '#types/locale.js';

export const reviewAudiencesPageLang = {
  [SupportedLocales.EN]: {
    pageTitle: 'Review Audiences',
    searchPlaceholder: 'Search',
    approve: 'Approve',
    approving: 'Approving...',
    reviewAudience: 'Review Audience',
    columns: {
      audienceName: 'Audience Name',
      status: 'Status',
      size: 'Size',
      createdBy: 'Created By',
      reviewers: 'Reviewers',
    },
    selectAll: 'Select all',
    selectRow: 'Select',
    tableAriaLabel: 'Audiences pending review',
    empty: {
      noMatches: {
        headline: 'There are no audiences to review.',
        caption: 'Create or submit an audience to approve',
        actionLabel: 'Go To Audiences',
      },
      setupAudience: {
        headline: 'Setup Audience Governance',
        caption: 'Setup audience review for your team',
        actionLabel: 'Setup',
      },
      noSetup: {
        headline: 'Audience Governance is not configured',
        caption: 'Audience review has not been configured for your team',
      },
    },
    approveSuccess: 'Successfully approved',
    approveError: 'Something went wrong while approving',
    loadError: 'Review audiences could not be loaded.',
    retry: 'Try again',
  },
  [SupportedLocales.ES]: {
    pageTitle: 'Revisar Audiencias',
    searchPlaceholder: 'Buscar',
    approve: 'Aprobar',
    approving: 'Aprobando...',
    reviewAudience: 'Revisar Audiencia',
    columns: {
      audienceName: 'Nombre de Audiencia',
      status: 'Estado',
      size: 'Tamaño',
      createdBy: 'Creado Por',
      reviewers: 'Revisores',
    },
    selectAll: 'Seleccionar todo',
    selectRow: 'Seleccionar',
    tableAriaLabel: 'Audiencias pendientes de revisión',
    empty: {
      noMatches: {
        headline: 'No hay audiencias para revisar.',
        caption: 'Crea o envía una audiencia para aprobar',
        actionLabel: 'Ir a Audiencias',
      },
      setupAudience: {
        headline: 'Configurar Gobernanza de Audiencia',
        caption: 'Configura la revisión de audiencia para tu equipo',
        actionLabel: 'Configurar',
      },
      noSetup: {
        headline: 'La Gobernanza de Audiencia no está configurada',
        caption:
          'La revisión de audiencia no ha sido configurada para tu equipo',
      },
    },
    approveSuccess: 'Aprobado exitosamente',
    approveError: 'Algo salió mal al aprobar',
    loadError: 'No se pudieron cargar las audiencias para revisar.',
    retry: 'Intentar de nuevo',
  },
};
